function getQuizzResultFromURL() {
  const queryString = window.location.search;
  localStorage.setItem("quizzUrlResult", queryString);
  const parsedResult = {
    profiles: [],
    responses: []
  };
  if (!queryString)
    return parsedResult;
  const searchParams = new URLSearchParams(queryString);
  const profilesParam = searchParams.get("profiles");
  if (profilesParam) {
    parsedResult.profiles = profilesParam.split(",");
  }
  const resultsParam = searchParams.get("responses");
  if (resultsParam) {
    parsedResult.responses = resultsParam.split(",");
    const resultsArray = resultsParam ? resultsParam.replace(/[\[\]_____]/g, "").split(",").filter(Boolean) : [];
    let formattedResults = resultsArray.map((item) => {
      const [key, value] = item.split(":");
      return { key: key.trim(), value: decodeURIComponent(value).trim() };
    }).filter((entry) => entry.value);
    let resultHTML = "";
    formattedResults.forEach((entry) => {
      resultHTML += `${entry.value},`;
    });
  }
  return parsedResult;
}
async function fetchQuizzSection(sectionId, data) {
  return new Promise(function(resolve, reject) {
    let qq, query;
    if (typeof data != "number") {
      query = data.profiles.join("_");
      qq = "&q=" + query;
    } else {
      qq = "&q=id:" + data;
    }
    const url = "/search/?sections=" + sectionId + qq + data.responses;
    fetch(url).then(function(r) {
      r.json().then(function(res) {
        var keys = Object.keys(res);
        if (keys.length > 0) {
          return resolve(res[keys[0]]);
        }
        return reject();
      });
    });
  });
}
async function initQuizz() {
  document.querySelector("quizz-preloader").classList.remove("!jc-hidden");
  const quizzResults = getQuizzResultFromURL();
  const parser = new DOMParser();
  const quizSection = window.quiz_results_section;
  const quizzContentResponse = await fetchQuizzSection(quizSection, quizzResults);
  let quizzHTML = parser.parseFromString(
    quizzContentResponse,
    "text/html"
  );
  console.log("quizzHTML", quizzHTML);
  const quizzSection = document.querySelector("quizz-content");
  quizzSection.innerHTML = quizzHTML.querySelector("quizz-content").innerHTML;
  document.dispatchEvent(new CustomEvent("diagnostic:klaviyo-payload-ready"));
  document.querySelector("quizz-preloader").classList.add("!jc-hidden");
}
window.addEventListener("DOMContentLoaded", async () => {
  initQuizz();
  if (window.location.pathname.indexOf("/quizz-result") != -1)
    ;
});
class QuizzPreloader extends HTMLElement {
  constructor() {
    super();
  }
  show() {
    this.classList.add("active");
  }
  hide() {
    this.classList.remove("active");
  }
}
customElements.define("quizz-preloader", QuizzPreloader);
class QuizzProductCard extends HTMLElement {
  constructor() {
    super();
    this.addToCart = this.querySelector("quiz-add-to-cart");
    this.options = this.querySelectorAll(".jc-variant-item");
    this.images = this.querySelectorAll(".jc-cart-product-image");
  }
  connectedCallback() {
    this.options.forEach((option, i) => {
      option.addEventListener("click", () => {
        let selectedVariant = option.dataset.variant;
        let activePrice = option.dataset.variantPrice;
        let activeComparePrice = option.dataset.variantComparePrice;
        this.addToCart.setAttribute("data-variant-id", selectedVariant);
        this.addToCart.querySelector(".jc-quiz-price").innerHTML = processString(activePrice);
        this.addToCart.querySelector(".jc-quiz-compare-price").innerHTML = processString(activeComparePrice);
        if (activeComparePrice > activePrice) {
          this.addToCart.querySelector(".jc-quiz-compare-price").classList.remove("jc-hidden");
        } else {
          this.addToCart.querySelector(".jc-quiz-compare-price").classList.add("jc-hidden");
        }
        if (this.images.length > 1) {
          this.images.forEach((image) => {
            image.setAttribute("data-active", false);
          });
          this.images[i].setAttribute("data-active", true);
        }
      });
    });
  }
}
customElements.define("quizz-product-card", QuizzProductCard);
class QuizResults extends HTMLElement {
  constructor() {
    super();
    this.toggleResults = this.querySelector(".jc-quiz-results-toggle");
    this.expanded = this.getAttribute("data-expanded") === "true";
    this.list = this.querySelector("ul");
  }
  connectedCallback() {
    this.toggleResults.addEventListener("click", () => {
      this.expanded = !this.expanded;
      this.setAttribute("data-expanded", this.expanded);
    });
  }
}
customElements.define("quiz-results", QuizResults);
class DetailsToggle extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details-toggle-btn");
    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.addEventListener("click", this.onToggle.bind(this));
    }
  }
  onToggle() {
    const isExpanded = this.getAttribute("aria-expanded") === "true";
    this.setAttribute("aria-expanded", !isExpanded);
  }
}
customElements.define("details-toggle", DetailsToggle);
function processString(input) {
  return input.replace(/,/g, "€").replace(/,00/g, "");
}
